import { render, staticRenderFns } from "./ReplaceKit.vue?vue&type=template&id=0cd4124c&"
import script from "./ReplaceKit.vue?vue&type=script&lang=js&"
export * from "./ReplaceKit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports